import React, { useState, useEffect } from "react";
import CopaySchedule from "../../../pages/CopaySchedule/CopaySchedule";
import CopayScheduleStep from "../../../pages/CopaySchedule/CopayScheduleStep";

const CopayScheduleStepLookUp = ({
  params,
  intialSchedule = "",
  onSelect,
  hideModal,
  selectMode,
  lookupType,
  scheduleFlag,
  selectParamsData,
  sourceData,
  onNavigate,
}) => {
  const scheduleKey = params[0].source;
  const intialScheduleName = intialSchedule[scheduleKey];
  const [schedule, setSchedule] = useState({
    ps4BrandCopaySchedule: intialScheduleName,
  });
  const [scheduleDesc, setScheduleDesc] = useState("");
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    const getScheduleDescription = () => {
      const copayScheduleName = selectParamsData.cscCopayScheduleName;
      let description = "";

      if (sourceData.ps4BrandCopaySchedule === copayScheduleName) {
        description = sourceData.brandCopayScheduleDesc;
      } else if (sourceData.ps4GenrcCopaySchedule === copayScheduleName) {
        description = sourceData.genericCopayScheduleDesc;
      }

      return {
        cshCopayScheduleDesc: description
          ? description
          : scheduleDesc.cshCopayScheduleDesc,
        cshCopayScheduleId: selectParamsData.cscCopayScheduleName,
        cscStepNbr: selectParamsData.cscStepNbr,
      };
    };

    if (selectParamsData.cscCopayScheduleName) {
      const newScheduleDesc = getScheduleDescription();
      setScheduleDesc(newScheduleDesc);
    }
  }, [
    selectParamsData.cscCopayScheduleName,
    selectParamsData.cscStepNbr,
    sourceData,
  ]);

  if (!selectParamsData.cscCopayScheduleName) {
    return (
      <div>
        {!flag && (
          <CopaySchedule
            params={params}
            onSelect={setSchedule}
            setFalg={setFlag}
            hideModal={hideModal}
            selectMode={selectMode}
            lookupType={lookupType}
            selectParamsData={selectParamsData}
            setScheduleDesc={setScheduleDesc}
            onNavigate={onNavigate}
          />
        )}
        {flag && (
          <CopayScheduleStep
            params={params}
            schedule={schedule}
            onSelect={onSelect}
            hideModal={hideModal}
            selectMode={selectMode}
            lookupType={lookupType}
            selectParamsData={selectParamsData}
            intialSchedule={intialSchedule}
            scheduleDesc={scheduleDesc}
            onNavigate={onNavigate}
          />
        )}
      </div>
    );
  } else {
    return (
      <div>
        {!scheduleDesc.cshCopayScheduleId && (
          <CopaySchedule
            params={params}
            onSelect={setSchedule}
            setFalg={setFlag}
            hideModal={hideModal}
            selectMode={selectMode}
            lookupType={lookupType}
            selectParamsData={selectParamsData}
            setScheduleDesc={setScheduleDesc}
            onNavigate={onNavigate}
          />
        )}
        {scheduleDesc.cshCopayScheduleId && (
          <CopayScheduleStep
            params={params}
            schedule={schedule}
            onSelect={onSelect}
            hideModal={hideModal}
            selectMode={selectMode}
            lookupType={lookupType}
            selectParamsData={selectParamsData}
            intialSchedule={intialSchedule}
            scheduleDesc={scheduleDesc}
            onNavigate={onNavigate}
          />
        )}
      </div>
    );
  }
};

export default CopayScheduleStepLookUp;
